import axios from '@/plugins/axios';

const initialState = () => {
    return {
        loggedUser: localStorage.getItem('loggedUser')
            ? JSON.parse(localStorage.getItem('loggedUser'))
            : null,
        userStats: {}
    };
};

const state = () => initialState();

const getters = {
    getLoggedUser: state => state.loggedUser,
    isAdmin: state => {
        if (state.loggedUser) {
            return state.loggedUser.roles.some(role => role.name === 'admin');
        }

        return false;
    },
    getUsersStats: state => state.userStats
};

const mutations = {
    setLoggedUser(state, loggedUser) {
        state.loggedUser = loggedUser;

        if (!loggedUser || typeof loggedUser !== 'object') {
            return;
        }

        localStorage.setItem('loggedUser', JSON.stringify(loggedUser));
    },
    clearStorage(state) {
        localStorage.removeItem('loggedUser');
        state.loggedUser = null;
    },
    setProfileImage(state, value) {
        state.loggedUser.profileImageFilePath = value
            ? value.profileImageFilePath
            : null;
        state.loggedUser.profileImageMinFilePath = value
            ? value.profileImageMinFilePath
            : null;

        if (!state.loggedUser || typeof state.loggedUser !== 'object') {
            return;
        }

        localStorage.setItem('loggedUser', JSON.stringify(state.loggedUser));
    },
    setUsersStats: (state, userStats) => {
        state.userStats = userStats;
    }
};

const actions = {
    async login({ commit }, credentials) {
        await axios.head('/auth/token');
        const { data } = await axios.post('/auth/login', credentials);

        commit('setLoggedUser', data);
        commit('settings/setSettings', data.userSettings, { root: true });
    },
    async logout({ commit }) {
        await axios.post('/auth/logout');

        commit('clearStorage');

        commit('contracts/clearState', null, { root: true });
        commit('holidays/clearState', null, { root: true });
        commit('notification/clearState', null, { root: true });
        commit('settings/clearState', null, { root: true });
        commit('users/clearState', null, { root: true });
        commit('vacations/clearState', null, { root: true });
    },
    async requestPasswordReset(vuexContext, email) {
        await axios.head('/auth/token');
        await axios.post('auth/forgot-password', { email });
    },
    async checkPasswordReset(vuexContext, token) {
        await axios.get(`auth/password-reset/${token}`);
    },
    async resetPassword({ commit }, { passwords, token }) {
        const { data } = await axios.post(
            `auth/password-reset/${token}`,
            passwords
        );

        commit('setLoggedUser', data);
        commit('settings/setSettings', data.userSettings, { root: true });
    },
    async refreshUser({ commit }, user) {
        commit('setLoggedUser', user);
    },
    async saveProfile(vuexContext, userData) {
        const { data } = await axios.put('auth/profile', userData);

        return data;
    },
    async saveNewPassword(vuexContext, passwords) {
        await axios.put('auth/change-password', passwords);
    },
    async storeProfileImage({ commit }, { image }) {
        const imageData = new FormData();

        imageData.append('image', image, image.name);

        const { data } = await axios.post('/auth/profile-image', imageData);

        commit('setProfileImage', data);
    },
    async removeProfileImage({ commit }) {
        await axios.delete('/auth/profile-image');

        commit('setProfileImage', null);
    },
    async fetchUsersStats({ commit }) {
        const { data } = await axios.get('/auth/stats');

        commit('setUsersStats', data);

        return data;
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
